import { useState } from "react";
import { useScrollPosition } from "@/hooks/useScrollPosition";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export function StickyHeader() {
  const { isPastHero } = useScrollPosition();
  const [mobileOpen, setMobileOpen] = useState(false);

  if (!isPastHero) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-40 bg-background/95 backdrop-blur-md shadow-sm border-b border-border animate-slide-up">
      <div className="container mx-auto px-4 h-14 flex items-center justify-between">
        <Link to="/" className="font-bold text-primary text-lg">Oyinbatfo</Link>
        <div className="hidden md:flex items-center gap-4">
          <Link to="/free-mockup" className="text-sm text-foreground hover:text-primary transition-colors">Free Mockup</Link>
          <Link to="/blog" className="text-sm text-foreground hover:text-primary transition-colors">Blog</Link>
          <Link to="/portfolio" className="text-sm text-foreground hover:text-primary transition-colors">Portfolio</Link>
        </div>
        <div className="flex items-center gap-2">
          <Button asChild size="sm" className="bg-[#e85a1f] hover:bg-[#d14d15] text-white font-semibold">
            <Link to="/free-mockup">Get Free Mockup</Link>
          </Button>
          <button
            className="md:hidden p-2 text-foreground"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
          </button>
        </div>
      </div>
      {mobileOpen && (
        <div className="md:hidden bg-background border-b border-border px-4 pb-4 space-y-2">
          <Link to="/free-mockup" onClick={() => setMobileOpen(false)} className="block text-sm py-2 text-foreground hover:text-primary">Free Mockup</Link>
          <Link to="/blog" onClick={() => setMobileOpen(false)} className="block text-sm py-2 text-foreground hover:text-primary">Blog</Link>
          <Link to="/portfolio" onClick={() => setMobileOpen(false)} className="block text-sm py-2 text-foreground hover:text-primary">Portfolio</Link>
        </div>
      )}
    </div>
  );
}
